<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-licencing_nr'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="addChannelName"
    @add_click="onAddLicencingNR"
  >
    <!-- :addLinkLabel="`${$t('add')} ${$t('new')} ${$dft.capHead(channel)}`" -->
    <NTable
      class="dbox1"
      id="royalty-contracts-sidewindow-licencing_nr-list"
      :config="tableConfig"
      :headers="headers"
      :items="list || []"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('channel')">
            <TextField2
              :id="'sequence_no'"
              :showLabel="false"
              :value="item['sequence_no']"
              @blur="e => onTextFieldValueChange(e, item)"
              :bb="'none'"
            />
          </td>
          <td v-bind="tdcon('rate')">
            <!-- <div class="percent-area"> -->
            <TextField2
              :ta="'right'"
              :id="'royalty_rate'"
              :showLabel="false"
              :type="'percent'"
              :value="item['royalty_rate']"
              @blur="e => onTextFieldValueChange(e, item)"
               :bb="'none'"
            />
            <!-- <span class="percent">% income</span> -->
            <!-- </div> -->
          </td>
          <td v-bind="tdcon('deductions_adjustments')">
            <span class="txtov" :title="item['deduction_display']">
              {{ item["deduction_display"] }}
            </span>
          </td>
          <td v-bind="tdcon('royalty_options')">
            <span class="txtov" :title="item['options_display']">
              {{ item["options_display"] }}
            </span>
          </td>
          <td v-bind="tdcon('exclude')">
            <div class="ut-rowcen">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="`exclude-${item['royalty_option_id']}`"
                  :id="`exclude-${item['royalty_option_id']}`"
                  :checked="item['exclude'] == '1'"
                  @click="e => onContractExclude(e, item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('edit')">
            <img
              src="static/icons/edit-blue.svg"
              @click.stop="e => onEditLicencingNR(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteLicencingNR(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { EventHooks } from "../../../../plugins/text-field";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["channel", "list"],
  data: function() {
    return {
      textFieldConfig: {
        height: 27,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      }
    };
  },
  mounted: function() {
    console.log("Channel---- ", this.channel);
  },
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    headers: function() {
      return [
        createTableHeader("channel", { mw: 100, text: this.channelName }),
        createTableHeader("rate", {
          mw: 70,
          ta: "right"
        }),
        createTableHeader("deductions_adjustments"),
        createTableHeader("royalty_options"),
        createTableHeader("exclude", { mw: 70, ta: "center" }),
        createTableHeader("edit", { text: false, mw: 30 }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },
    addChannelName: function() {
      return this.channel == "Add New Performance"
        ? `${this.$t("add_new")} ${this.$t("performance")}`
        : `${this.$t("add_new")} ${this.$t("thirdparty_title")}`;
    },
    channelName: function() {
      return this.channel == "Add New Performance"
        ? `${this.$t("performance_title")}`
        : `${this.$t("thirdparty_title")}`;
    }
  },
  methods: {
    onAddLicencingNR: function() {
      this.$emit("added", true);
    },

    onEditLicencingNR: function(selectedItem) {
      this.$emit("edited", selectedItem);
    },

    onTextFieldValueChange: function({ name, value }, item) {
      this.$emit("changed", { name, value, item });
    },

    onContractExclude: function(e, item) {
      if (e.target.checked) {
        this.$emit("changed", {
          name: "exclude",
          value: 1,
          item,
          contract_id: this.list.contract_id
        });
      } else {
        this.$emit("changed", {
          name: "exclude",
          value: 0,
          item,
          contract_id: this.list.contract_id
        });
      }
    },

    onDeleteLicencingNR: async function(item) {
      this.$emit("deleted", item);
      // const confirmationResult = await confirmDelete(
      //   "licencing",
      //   item.sequence_no
      // );
      // if (confirmationResult === "OK") {
      //   this.$emit("deleted", item);
      // }
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-licencing_nr {
  .royalty-contracts-sidewindow-licencing_nr-list {
    .percent-area {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 3px !important;
      margin-left: 3px !important;

      .fc2-textfield {
        flex: 1;
        width: 50%;
      }

      .percent {
        display: block;
      }
    }
  }
}
</style>
